/* eslint-disable react/destructuring-assignment */
import React from "react";

const DownIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.64626 9.55241L7.99981 9.90596L8.35336 9.55241L11.9526 5.95315C11.9526 5.95314 11.9526 5.95313 11.9526 5.95312C11.9787 5.92708 12.0209 5.92708 12.0469 5.95315C12.0729 5.97918 12.0729 6.02137 12.0469 6.0474C12.0469 6.04741 12.0469 6.04742 12.0469 6.04743L8.04692 10.0474L8.40047 10.4009L8.04692 10.0474C8.02085 10.0734 7.9787 10.0734 7.95263 10.0474L7.61591 10.3841L7.95263 10.0474L3.95263 6.0474C3.95263 6.0474 3.95263 6.0474 3.95263 6.0474C3.92659 6.02136 3.9266 5.97915 3.95263 5.95313L3.95263 5.95312C3.97867 5.92708 4.02088 5.92708 4.04691 5.95312L4.04692 5.95312L7.64626 9.55241Z"
        fill="white"
        stroke={props.color || "#334155"}
      />
    </svg>
  );
};

export default DownIcon;
